
    export default {
        name: 'LeeCollapseItem',
        inheritAttrs: false,
        data() {
            return {}
        },
        inject: ['collapse'],
        methods: {
            chuli(item) {
                if (this.collapse.accordion) {
                    let temitem=[]
                    if (this.collapse.value == item) {
                        this.collapse.$emit('input',[])
                    } else {
                        temitem.push(item)
                        this.collapse.$emit('input',temitem)
                    }
                } else {
                    if (this.collapse.value.indexOf(item) < 0) {
                        this.collapse.value.push(item)
                    } else {
                        let index = this.collapse.value.indexOf(item)
                        this.collapse.value.splice(index, 1)
                    }
                }
            },
            enter(el) {
                var h = el.scrollHeight
                el.style.setProperty('--h', h + 'px')
            },
            afterenter(el) {
                el.removeAttribute('style')
            },
            leave(el) {
                var h = el.scrollHeight
                el.style.setProperty('--h', h + 'px')
            },
            afterleave(el) {
                el.style.setProperty('--h', '')
            }
        },
        props: {
            title: {
                type: String,
                default: '' //默认default
            },
            name: {
                type: String,
                default: '' //默认default
            }
        }
    };
